import { InviteColleagueRequest, InviteExternalRequest } from '@front-app/services/GroupsApi/GroupsMemberApi';
import { FullUser, UserRole } from '@front-app/services/UserApi/UserModel';
import { MemberTypeOption } from '../components/admin/addMembers/addMembers';

export const idsToColleagueInvites = (ids: string[], role: MemberTypeOption): InviteColleagueRequest[] => ids.map((userId) => ({
	userId,
	role: role === UserRole.MEMBER ? UserRole.INVITEE : role,
}));

export const emailsToExternalInvites = (emails: string[], role: MemberTypeOption): InviteExternalRequest[] => emails
	.map((email: string) => ({
		email,
		role: role === UserRole.MEMBER ? UserRole.INVITEE : role,
		firstName: '',
		lastName: '',
	}));

export const getColleagueEmails = (colleagues: FullUser[]): string => {
	let emailList = '';
	colleagues.forEach((colleague) => {
		emailList += colleague.email;
	});
	return emailList;
};
